import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { RegisterService } from '../../core/services/register.service';
import { ToastService } from '../../shared/services/toast.service';
import { ToastComponent } from '../../shared/components/toast/toast.component';
import { I18nPipe } from '../../shared/pipes/i18n.pipe';
import { I18nService } from '../../core/services/i18n.service';

@Component({
  selector: 'umkt-success-register',
  standalone: true,
  imports: [CommonModule, ToastComponent, I18nPipe],
  templateUrl: './success-register.component.html',
  styleUrls: ['./success-register.component.scss']
})
export class SuccessRegisterComponent {
  email: string = '';
  loading = false;
  currentYear = new Date().getFullYear();
  isTokenFlow = false;
  private readonly CONTEXT_KEY = 'umkt_success_register_context';
  private router = inject(Router);
  private registerService = inject(RegisterService);
  private toastService = inject(ToastService);
  private i18nService = inject(I18nService);

  constructor() {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.email = navigation.extras.state['email'] || '';
      this.isTokenFlow = navigation.extras.state['isTokenFlow'] || false;
    }

    if (!this.email && history.state) {
      this.email = history.state.email || '';
      this.isTokenFlow = history.state.isTokenFlow || false;
    }

   
    if (!this.email) {
      this.loadFromSessionContext();
    }
  }

  private loadFromSessionContext(): void {
    try {
      if (typeof sessionStorage === 'undefined') return;

      const raw = sessionStorage.getItem(this.CONTEXT_KEY);
      if (!raw) return;

      const parsed = JSON.parse(raw) as { email?: string; isTokenFlow?: boolean; createdAt?: number };
      const createdAt = parsed?.createdAt || 0;

      const ttlMs = 10 * 60 * 1000;
      if (!createdAt || Date.now() - createdAt > ttlMs) {
        sessionStorage.removeItem(this.CONTEXT_KEY);
        return;
      }

      this.email = parsed.email || '';
      this.isTokenFlow = Boolean(parsed.isTokenFlow);

      sessionStorage.removeItem(this.CONTEXT_KEY);
    } catch { /* empty */ }
  }

  resendEmail(): void {
    if (!this.email) {
      this.toastService.showError(
        this.i18nService.instant('pages.successRegister.messages.emailNotFound'), 
        3000, 
        'top-center'
      );
      return;
    }

    this.loading = true;
    this.registerService.resendConfirmationEmail(this.email).subscribe({
      next: (response) => {
        this.loading = false;
        this.toastService.showSuccess(
          this.i18nService.instant('pages.successRegister.messages.success'), 
          3000, 
          'top-center'
        );
      },
      error: (error) => {
        this.loading = false;
        console.error('Erro ao reenviar email:', error);
        this.toastService.showError(
          this.i18nService.instant('pages.successRegister.messages.error'), 
          5000, 
          'top-center'
        );
      }
    });
  }
}
